export const AGGREGATION_POLICIES_RESET_STATE = 'AGGREGATION_POLICIES_RESET_STATE';
export const AGGREGATION_POLICIES_CURRENT_ITEM = 'AGGREGATION_POLICIES_CURRENT_ITEM';

export const AGGREGATION_POLICIES_REQUEST_LOADING = 'AGGREGATION_POLICIES_REQUEST_LOADING';
export const AGGREGATION_POLICIES_REQUEST_SUCCESS = 'AGGREGATION_POLICIES_REQUEST_SUCCESS';
export const AGGREGATION_POLICIES_REQUEST_FAILED = 'AGGREGATION_POLICIES_REQUEST_FAILED';

export const AGGREGATION_POLICIES_CURRENT_ACTION = 'AGGREGATION_POLICIES_CURRENT_ACTION';
export const AGGREGATION_POLICIES_RESET_ACTION = 'AGGREGATION_POLICIES_RESET_ACTION';